// === View Switcher (Grid / List) ===

import store from '../state/store.js';
import { getElements } from '../utils/dom.js';
import { renderCards } from './card-renderer.js';

export function setView(mode) {
  const els = getElements();
  store.currentView = mode;
  els.btnGrid.classList.toggle('active', mode === 'grid');
  els.btnList.classList.toggle('active', mode === 'list');

  const containers = [els.urgentGrid, els.normalGrid];
  containers.forEach(el => {
    el.classList.remove('grid-layout', 'list-layout');
    el.classList.add(`${mode}-layout`);
  });

  renderCards();
}
